import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";
 
const ProductTest = () => {
 
  return (
    <>
      <Header />
 
      <div className="breadcrumb-bar text-center">
  <div className="container">
    <div className="row">
      <div className="col-md-12 col-12">
        <h2 className="breadcrumb-title mb-2">Service Details</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb justify-content-center mb-0">
            <li className="breadcrumb-item">
              <a href="https://truelysell-laravel.dreamstechnologies.com">
                <i className="ti ti-home-2" />
              </a>
            </li>
            <li className="breadcrumb-item">Services</li>
            <li className="breadcrumb-item active" aria-current="page">
              Service Details
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</div>


     <div className="container" style={{ transform: "none" }}>
      <div className="row" style={{ transform: "none" }}>
        <div className="col-xl-8">
          <div className="card border-0">
            <div className="card-body">
              <div className="service-head mb-2">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <h3 className="mb-2">10K Car Washing555</h3>
                  <span className="badge badge-purple-transparent mb-2">
                    <i className="ti ti-calendar-check me-1" />
                    44+ Bookings
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                  <div className="d-flex align-items-center flex-wrap">
                    <p className="me-3 mb-2">
                      <i className="ti ti-map-pin me-2" />
                      Sevlievo, Lovech
                    </p>
                    <p className="mb-2">
                      <i className="ti ti-star-filled text-warning me-2" />
                      <span className="text-gray-9">3.0 </span>(1 reviews)
                    </p>
                  </div>
                  <div className="d-flex align-items-center flex-wrap">
                    <a href="javscript:void(0);" className="me-3 mb-2">
                      <i className="ti ti-eye me-2" />
                      378 Views
                    </a>
                  </div>
                </div>
              </div>
              <div className="service-wrap mb-4">
            
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png" className="rounded-4" />
              </div>
              <div className="accordion service-accordion">
                <div className="accordion-item mb-4">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button p-0"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#overview"
                      aria-expanded="false"
                    >
                      Service Overview
                    </button>
                  </h2>
                  <div
                    id="overview"
                    className="accordion-collapse collapse show"
                  >
                    <div className="accordion-body border-0 p-0 pt-3">
                      <div className="more-text">
                        <p>
                          Touchless car washes, which use high-pressure water
                          and gentle soaps, are a great option. This type of
                          wash will effectively remove dirt, grime, and other
                          contaminants without risking scratches or damage to
                          the paint. Another option is handwashing, which can be
                          very effective in maintaining your car's appearance.{" "}
                        </p>
                      </div>
                      <a
                        href="javascript:void(0);"
                        className="link-primary text-decoration-underline more-btn mb-4"
                      >
                        Read More
                      </a>
                      <div className="bg-light-200 p-3 offer-wrap">
                        <h4 className="mb-3">Services Offered</h4>
                        {/*
														<div class="d-flex align-items-center justify-content-between mb-3">
															<h6 class="fs-16 fw-medium mb-0"> Bike Service															<p>$10.00</p>
														</div>
													*/}
                        <div className="offer-item d-md-flex align-items-center justify-content-between bg-white mb-2">
                          <div className="d-sm-flex align-items-center mb-2">
                            <span className="avatar avatar-lg flex-shrink-0 me-2 mb-2">
                              <img
                                src="https://truelysell-laravel.dreamstechnologies.com/storage"
                                alt="img"
                                className="br-10"
                              />
                            </span>
                            <div className="mb-2">
                              <h6 className="fs-16 fw-medium">Bike Service</h6>
                              <p className="fs-14">Touchless car washes</p>
                            </div>
                          </div>
                          <div className="pb-3">
                            <h6 className="fs-16 fw-medium text-primary mb-0">
                              Mad10.00
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div
                        className="bg-light-200 p-3 offer-wrap"
                        style={{ display: "none" }}
                      >
                        <h4 className="mb-3">Services Offered</h4>
                        <div className="offer-item d-md-flex align-items-center justify-content-between bg-white mb-2">
                          <div className="d-sm-flex align-items-center mb-2">
                            <span className="avatar avatar-lg flex-shrink-0 me-2 mb-2">
                              <img src="" alt="img" className="br-10" />
                            </span>
                            <div className="mb-2">
                              <h6 className="fs-16 fw-medium">Bike Service</h6>
                              <p className="fs-14">Touchless car washes</p>
                            </div>
                          </div>
                          <div className="pb-3">
                            <h6 className="fs-16 fw-medium text-primary mb-0">
                              Mad10.00
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item mb-4">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button p-0"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#include"
                      aria-expanded="true"
                    >
                      Includes
                    </button>
                  </h2>
                  <div
                    id="include"
                    className="accordion-collapse collapse show"
                    style={{}}
                  >
                    <div className="accordion-body border-0 p-0 pt-3">
                      <div className="bg-light-200 p-3 pb-2 br-10">
                        <p className="d-inline-flex align-items-center mb-2 me-4">
                          <i className="feather-check-circle text-success me-2" />
                          Bike
                        </p>
                        <p className="d-inline-flex align-items-center mb-2 me-4">
                          <i className="feather-check-circle text-success me-2" />
                          Car
                        </p>
                        <p className="d-inline-flex align-items-center mb-2 me-4">
                          <i className="feather-check-circle text-success me-2" />
                          Truck
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item mb-4">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button p-0"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#gallery"
                      aria-expanded="false"
                    >
                      Gallery
                    </button>
                  </h2>
                  <div
                    id="gallery"
                    className="accordion-collapse collapse show"
                  >
                    <div className="accordion-body border-0 p-0 pt-3">
                      <div className="gallery-slider owl-carousel nav-center gallery-img owl-loaded owl-drag">
                        <div className="owl-stage-outer">
                          <div
                            className="owl-stage"
                            style={{
                              transform: "translate3d(0px, 0px, 0px)",
                              transition: "all",
                              width: 141
                            }}
                          >
                            <div
                              className="owl-item active"
                              style={{ width: "124.331px", marginRight: 16 }}
                            >
                              <a
                                href="https://truelysell-laravel.dreamstechnologies.com/storage/logos/toVMzhD7PYdjWM7P1AJ0pl9SDap2kY0UAqTixKCQ.jpg"
                                data-fancybox="gallery"
                                className="gallery-item"
                              >
                                <img
                                  src="https://truelysell-laravel.dreamstechnologies.com/storage/logos/toVMzhD7PYdjWM7P1AJ0pl9SDap2kY0UAqTixKCQ.jpg"
                                  alt="img"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="owl-nav disabled">
                          <button
                            type="button"
                            role="presentation"
                            className="owl-prev disabled"
                          >
                            <i className="fa-solid fa-chevron-left" />
                          </button>
                          <button
                            type="button"
                            role="presentation"
                            className="owl-next disabled"
                          >
                            <i className="fa-solid fa-chevron-right" />
                          </button>
                        </div>
                        <div className="owl-dots disabled" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card border-0 mb-xl-0 mb-4">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="mb-3" id="total_review_count">
                  Reviews (1)
                </h4>
                <a
                  className="nav-link btn btn-light"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#login-modal"
                >
                  Write a Review
                </a>
              </div>
              <div className="row align-items-center">
                <div className="col-md-5">
                  <div className="rating-item bg-light-500 text-center mb-3">
                    <h5 className="mb-3">Customer Reviews &amp; Ratings</h5>
                    <div
                      className="d-inline-flex align-items-center justify-content-center"
                      id="stars_container"
                    >
                      <i className="ti ti-star-filled text-warning me-1" />
                      <i className="ti ti-star-filled text-warning me-1" />
                      <i className="ti ti-star-filled text-warning me-1" />
                      <i className="ti ti-star text-warning me-1" />
                      <i className="ti ti-star text-warning me-1" />
                    </div>
                    <p className="mb-3" id="avg_rating">
                      (3.0 out of 5.0)
                    </p>
                    <p className="text-gray-9" id="totalReviewCount">
                      Basedon 1 Reviews
                    </p>
                  </div>
                </div>
                <div className="col-md-7">
                  <div
                    className="rating-progress mb-3"
                    id="review_progress_container"
                  >
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">5 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: "0%" }}
                        />
                      </div>
                      <p className="progress-count ms-2">0</p>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">4 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: "0%" }}
                        />
                      </div>
                      <p className="progress-count ms-2">0</p>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">3 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={100}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <p className="progress-count ms-2">1</p>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">2 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: "0%" }}
                        />
                      </div>
                      <p className="progress-count ms-2">0</p>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">1 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: "0%" }}
                        />
                      </div>
                      <p className="progress-count ms-2">0</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list-reviews">
                <div className="card review-item mb-3">
                  <div className="card-body p-3 review_item" id="reply_38">
                    <div className="review-info">
                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <div className="d-flex align-items-center mb-2">
                          <span className="avatar avatar-lg me-2 flex-shrink-0">
                            <img
                              src="https://truelysell-laravel.dreamstechnologies.com/storage/profile/c3f61dcc-3ea4-48b2-905d-ed8bdfb4682f_1744661978.jpg"
                              className="rounded-circle"
                              alt="img"
                            />
                          </span>
                          <div>
                            <h6 className="fs-16 fw-medium">Demo</h6>
                            <div className="d-flex align-items-center flex-wrap date-info">
                              <p className="fs-14 mb-0">2 weeks ago</p>
                            </div>
                          </div>
                        </div>
                        <span className="badge bg-success d-inline-flex align-items-center mb-2">
                          <i className="ti ti-star-filled me-1" />3
                        </span>
                      </div>
                      <p className="mb-2">hi</p>
                      <div className="d-flex align-items-center justify-content-between flex-wrap like-info">
                        <div className="d-inline-flex align-items-center">
                          <a
                            href="javascript:void(0);"
                            className="d-inline-flex align-items-center me-2 reply_review"
                            data-id={38}
                          >
                            <i className="fas fa-reply me-1" />
                            Reply
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="review-info reply mt-2 mb-2 p-3">
                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <div className="d-flex align-items-center mb-2">
                          <span className="avatar avatar-lg me-2 flex-shrink-0">
                            <img
                              src="https://truelysell-laravel.dreamstechnologies.com/storage/profile/c3f61dcc-3ea4-48b2-905d-ed8bdfb4682f_1744661978.jpg"
                              className="rounded-circle"
                              alt="img"
                            />
                          </span>
                          <div>
                            <h6 className="fs-16 fw-medium">Demo</h6>
                            <div className="d-flex align-items-center flex-wrap date-info">
                              <p className="fs-14 mb-0">2 weeks ago</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p className="mb-2">hi</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-xl-4 theiaStickySidebar"
          style={{
            position: "relative",
            overflow: "visible",
            boxSizing: "border-box",
            minHeight: 1
          }}
        >
          <div
            className="theiaStickySidebar"
            style={{
              paddingTop: 0,
              paddingBottom: 1,
              position: "static",
              transform: "none",
              top: 0,
              left: "997.588px"
            }}
          >
            <div className="card border-0">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                  <div className="d-flex align-items-center">
                    <div className="mb-3">
                      <h4>
                        <span className="display-6 fw-bold">Mad200</span> /{" "}
                        <span className="text-default">Minute</span>
                      </h4>
                    </div>
                  </div>
                </div>
                {/* <form enctype="multipart/form-data" method="POST" action="https://truelysell-laravel.dreamstechnologies.com/book">
													<h4 class="mb-3">Services Offered</h4>
							

								<div class="d-flex align-items-center justify-content-between mb-3">
									<h6 class="fs-16 fw-medium mb-0">
										<input class="form-check-input" name="service_offer[]" type="checkbox" value="Bike Service_10.00"> Bike Service									</h6>
									<p>Mad10.00</p>
								</div>
																	<a class="nav-link btn btn-light" href="#" data-bs-toggle="modal" data-bs-target="#login-modal"><i class="ti ti-calendar me-2"></i>Book Service</a>
									</div>
			</div>
			<!-- my booking */}
                <a
                  className="nav-link btn btn-light"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#login-modal"
                >
                  <i className="ti ti-calendar me-2" />
                  Book Service
                </a>
                <div className="card border-0">
                  <div className="card-body">
                    <h4 className="mb-3">Service Provider</h4>
                    <div className="provider-info text-center bg-light-500 p-3 mb-3">
                      <div className="avatar avatar-xl mb-3">
                        <img
                          src="https://truelysell-laravel.dreamstechnologies.com/storage/profile/27965256-0345-406f-b6ac-6be8f75cea85_1740063931.jpg"
                          alt="img"
                          className="img-fluid rounded-circle"
                        />
                        <span className="service-active-dot">
                          <i className="ti ti-check" />
                        </span>
                      </div>
                      <h5>Demo Admin</h5>
                      <p className="fs-14">
                        <i className="ti ti-star-filled text-warning me-2" />
                        <span className="text-gray-9 fw-semibold">3.0</span> (1
                        reviews)
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-user text-default me-2" />
                        Member Since
                      </h6>
                      <p>N/A</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-map-pin me-1" />
                        Address
                      </h6>
                      <p>Sevlievo, Lovech</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-mail me-1" />
                        Email
                      </h6>
                      <p>XXXX@XXXX.com</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-phone me-1" />
                        Phone
                      </h6>
                      <p>+X XXX XXX XXXX</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-file-text me-1" />
                        No of Listings
                      </h6>
                      <p>7</p>
                    </div>
                  </div>
                </div>
                <div className="card border-0">
                  <div className="card-body">
                    <h4 className="mb-3">Location</h4>
                    <div className="map-wrap">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6509170.989457427!2d-123.80081967108484!3d37.192957227641294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2sin!4v1669181581381!5m2!1sen!2sin"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="contact-map"
                      />
                      <div className="map-location bg-white d-flex align-items-center">
                        <div className="d-flex align-items-center me-2">
                          <div className="ms-2 overflow-hidden">
                            <p className="two-line-ellipsis">
                              12301 Lake Underhill Rd, Suite 126, Orlando, 32828
                            </p>
                          </div>
                        </div>
                        <span>
                          <i className="feather-send fs-16" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="resize-sensor"
              style={{
                position: "absolute",
                inset: 0,
                overflow: "hidden",
                zIndex: -1,
                visibility: "hidden"
              }}
            >
              <div
                className="resize-sensor-expand"
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  overflow: "hidden",
                  zIndex: -1,
                  visibility: "hidden"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    transition: "all",
                    width: 450,
                    height: 2070
                  }}
                />
              </div>
              <div
                className="resize-sensor-shrink"
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  overflow: "hidden",
                  zIndex: -1,
                  visibility: "hidden"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    transition: "0s",
                    width: "200%",
                    height: "200%"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
   



      <Footer />
    </>
  );
};

export default ProductTest;
